import { render, staticRenderFns } from "./QuestionPop.vue?vue&type=template&id=2ef82ab8&scoped=true"
import script from "./QuestionPop.vue?vue&type=script&lang=ts"
export * from "./QuestionPop.vue?vue&type=script&lang=ts"
import style0 from "./QuestionPop.vue?vue&type=style&index=0&id=2ef82ab8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef82ab8",
  null
  
)

export default component.exports